import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Group } from "@/db/schema";

export function renderDynamicFields(
  fields: Group["dynamicFields"],
  values?: Record<string, string>,
  onChange?: (id: string, value: string) => void,
  target = "event" as "event" | "resource",
) {
  if (!fields || fields.length === 0) return null;

  const filteredFields = fields.filter((field) => field.target === target);

  if (filteredFields.length === 0) return null;

  return (
    <div className="space-y-4">
      {filteredFields.map((field) => (
        <div key={field.id} className="flex flex-col gap-2">
          <Label htmlFor={`dynamic-${field.id}`}>
            {field.name}
            {field.required && <span className="text-red-500 ml-1">*</span>}
          </Label>
          <Input
            id={`dynamic-${field.id}`}
            name={`dynamic-${field.id}`}
            placeholder={field.name}
            defaultValue={values?.[field.id] || ""}
            required={field.required}
            onChange={(e) => onChange?.(field.id, e.target.value)}
          />
        </div>
      ))}
    </div>
  );
}
